import React from 'react'

export const PAGINATED_LIST_TABLE_CELL_TEXT_CLASS =
    'paginated-list-table-cell-text'

const getPaginatedListTextTitle = (
    value: React.ReactNode
): string | undefined => {
    if (typeof value === 'string' || typeof value === 'number') {
        const text = String(value)
        return text.length > 0 ? text : undefined
    }
    return undefined
}

export const renderPaginatedListText = (value: React.ReactNode) => {
    const isEmptyValue = value === null || value === undefined || value === ''
    const displayValue = isEmptyValue ? '-' : value

    return (
        <span
            className={PAGINATED_LIST_TABLE_CELL_TEXT_CLASS}
            title={isEmptyValue ? undefined : getPaginatedListTextTitle(displayValue)}
        >
            {displayValue}
        </span>
    )
}
